import { Modal, useModals } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

import Styles from './WeeklyPostLimitReachedModal.module.scss'

export const WeeklyPostLimitReachedModal = observer(() => {
  const { openModal, closeModal } = useModals()
  const { tierUsageStore } = useRootStore()
  const starterPlan = tierUsageStore.autopilotPlans.find((p) => p.key === PaymentPlanKey.BlazeAutopilotStarter)

  const handleComparePlans = () => {
    openModal(AutopilotPlansModal, {})
  }

  const handleUpgrade = () => {
    if (!starterPlan) {
      openModal(AutopilotPlansModal, {})
      return
    }
    openModal(AutopilotPlansModal, {
      initialStep: 'selected',
      initialPlanAndPrice: { plan: starterPlan, price: undefined },
    })
  }

  return (
    <Modal.Root onClose={closeModal} onPressOutside={closeModal} size="md">
      <Modal.Header title="You've reached your weekly post limit" onClose={closeModal} />
      <Modal.Content>
        <div className={Styles.body}>
          <Heading level={4}>You've scheduled the maximum of 200 posts for this week.</Heading>
          <Text color="var(--dark-60)">
            Upgrade to Starter or Growth to publish more content, unlock higher weekly limits, and keep your campaigns
            running without interruptions.
          </Text>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={handleComparePlans}>
            Compare Plans
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" onPress={handleUpgrade}>
            Upgrade to Starter
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
})
